import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'

const VehicleEditorButtons = ({ closeModal, disabled, updateVehicle, editVehicle }) =>
  <Fragment>
    <UpdateButton
      data-at-editvehiclemodal-updatevehicle
      full="mobile"
      stacked="mobile"
      narrow
      disabled={ editVehicle === false || disabled }
      onClick={ updateVehicle }>Update Vehicle</UpdateButton>
    <CustomButton
      data-at-editvehiclemodal-cancel
      full="mobile"
      narrow
      onClick={ closeModal }>
      Cancel
    </CustomButton>
  </Fragment>

export default VehicleEditorButtons

VehicleEditorButtons.propTypes = {
  closeModal: PropTypes.func,
  disabled: PropTypes.bool,
  editVehicle: PropTypes.bool,
  updateVehicle: PropTypes.func
}

const UpdateButton = styled(Button)`
  cursor: pointer;
`

const CustomButton = styled(Button)`
  margin: 22px 0 0 0;
  color: ${Theme.colors.bright_red_new};
  background: ${Theme.colors.transparent};
  border: 1px solid ${Theme.colors.transparent};
  cursor: pointer;

  &:hover {
    background: ${Theme.colors.transparent};
    color: ${Theme.colors.crimson};
    border-color: ${Theme.colors.crimson};
  }
`
